import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { UseCase } from "../../base/use-case";
import { LocationsRepository } from "../../repositories";
import { UpdateLocationDetailRequest } from "../../domain/requests/locations/update-location-details-request";

@Injectable({ providedIn: 'root' })
export class UpdateLocationDetailsUsecase implements UseCase<UpdateLocationDetailRequest[], boolean> {

  constructor(private readonly locationRepository: LocationsRepository) {
  }

  execute(params: UpdateLocationDetailRequest[]): Observable<boolean> {
    return this.locationRepository.updateLocationDetail(params);
  }

}
